export type IdIterator<T> = {
  next(): T;
  decrement(): void;
};

export function createIterator<T extends number>(firstValue = 0): IdIterator<T> {
  let _i = firstValue;
  return {
    next() {
      return _i++ as T;
    },
    decrement() {
      _i--;
    },
  };
}
